<template>
  <div style="width: 100%; display: flex; flex-direction: row;">
    <b-dropdown text="Tool" class="dropdown" variant="primary">
      <b-dropdown-item>Premiere Pro</b-dropdown-item>
      <b-dropdown-item>After Effects</b-dropdown-item>
      <b-dropdown-item>Photoshop</b-dropdown-item>
      <b-dropdown-item>Illustrator</b-dropdown-item>
      <b-dropdown-item>Media Encoder</b-dropdown-item>
      <b-dropdown-item>Indesign</b-dropdown-item>
      <b-dropdown-item>Miro</b-dropdown-item>
      <b-dropdown-item>Figma</b-dropdown-item>
      <b-dropdown-item>Blender</b-dropdown-item>
    </b-dropdown>
    <b-dropdown text="Topic" class="dropdown" variant="primary">
      <b-dropdown-item>Video</b-dropdown-item>
      <b-dropdown-item>UI/UX</b-dropdown-item>
      <b-dropdown-item>Photo</b-dropdown-item>
      <b-dropdown-item>Graphic Design</b-dropdown-item>
      <b-dropdown-item>Programming</b-dropdown-item>
      <b-dropdown-item>Illustration</b-dropdown-item>
      <b-dropdown-item>3D</b-dropdown-item>
    </b-dropdown>
    <b-dropdown text="Media type" class="dropdown" variant="primary">
      <b-dropdown-item>Video</b-dropdown-item>
      <b-dropdown-item>Text</b-dropdown-item>
      <b-dropdown-item>Downloads</b-dropdown-item>
      <b-dropdown-item>Plugins</b-dropdown-item>
    </b-dropdown>
    <b-dropdown text="Rating" class="dropdown" variant="primary">
      <b-dropdown-item>★</b-dropdown-item>
      <b-dropdown-item>★★</b-dropdown-item>
      <b-dropdown-item>★★★</b-dropdown-item>
      <b-dropdown-item>★★★★</b-dropdown-item>
    </b-dropdown>
    <b-dropdown
      text="Skill Level" class="dropdown" variant="primary">
      <b-dropdown-item>Beginner</b-dropdown-item>
      <b-dropdown-item>Medium</b-dropdown-item>
      <b-dropdown-item>Pro</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'FilterComponent',
};
</script>

<style>

</style>
